<template>
  <div id="app">
    <HeaderNav />
    <main class="main-content">
      <router-view />
    </main>
    <WhatsAppButton />
    <LoadingSpinner :show="isLoading" :message="loadingMessage" />
    <ToastNotification
      :show="toastState.show"
      :type="toastState.type"
      :title="toastState.title"
      :message="toastState.message"
      @close="hideToast"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex'
import HeaderNav from './components/HeaderNav.vue'
import WhatsAppButton from './components/WhatsAppButton.vue'
import LoadingSpinner from './components/LoadingSpinner.vue'
import ToastNotification from './components/ToastNotification.vue'

const store = useStore()

const isLoading = computed(() => store.getters['ui/isLoading'])
const loadingMessage = computed(() => store.getters['ui/loadingMessage'])
const toastState = computed(() => store.getters['ui/toastState'])

const hideToast = () => {
  store.dispatch('ui/hideToast')
}
</script>

<style>
#app {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  overflow-x: hidden;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  line-height: 1.6;
  color: #333;
  overflow-x: hidden;
  width: 100%;
}

/* Global button styles */
button {
  cursor: pointer;
  border: none;
  outline: none;
}

/* Global link styles */
a {
  text-decoration: none;
  color: inherit;
}

/* Smooth scrolling */
html {
  scroll-behavior: smooth;
  width: 100%;
  overflow-x: hidden;
}

/* Main content spacing for fixed header */
.main-content {
  padding-top: 120px;
  min-height: calc(100vh - 120px);
  width: 100%;
}

/* Responsive adjustments for main content */
@media (max-width: 768px) {
  .main-content {
    padding-top: 115px;
    min-height: calc(100vh - 115px);
  }
}

@media (max-width: 480px) {
  .main-content {
    padding-top: 108px;
    min-height: calc(100vh - 108px);
  }
}

@media (max-width: 360px) {
  .main-content {
    padding-top: 103px;
    min-height: calc(100vh - 103px);
  }
}
</style>
